import {parseSearchQuery} from "../store/actions/calculatorActions";
import {store} from "../index";

export const CALCULATOR_TYPES = {
  hoeveelKanIkLenen: 'hoeveel-kan-ik-lenen',
  watWordenMijnMaandLasten: 'wat-worden-mijn-maandlasten',
  kanIkDitHuisBetalen: 'kan-ik-dit-huis-betalen'
};

export const mainMediaMobile = "(max-width: 1024px)";

const PATH_TO_TYPE_MAP = {
  'hoeveel-kan-ik-lenen': CALCULATOR_TYPES.hoeveelKanIkLenen,
  'kan-ik-dit-huis-betalen': CALCULATOR_TYPES.kanIkDitHuisBetalen,
  'wat-worden-mijn-maandlasten': CALCULATOR_TYPES.watWordenMijnMaandLasten,
  'maximum-mortgage': CALCULATOR_TYPES.hoeveelKanIkLenen,
  'mortgage-payment': CALCULATOR_TYPES.watWordenMijnMaandLasten,
  'can-i-afford-this-house': CALCULATOR_TYPES.kanIkDitHuisBetalen
};

export const getCalculatorType = () => {
  const { pathname } = window.location;
  const queryParams = parseSearchQuery(window.location.search);
  let type = CALCULATOR_TYPES.watWordenMijnMaandLasten; // Default type

  for (const path in PATH_TO_TYPE_MAP) {
    if (pathname.includes(path)) {
      type = PATH_TO_TYPE_MAP[path];
      break;
    }
  }

  if (queryParams && typeof queryParams.type !== 'undefined' && PATH_TO_TYPE_MAP[queryParams.type]) {
    type = PATH_TO_TYPE_MAP[queryParams.type];
  }

  return type;
};

export const stepStates = {
    active: "active",
    filled: "filled",
    inactive: "inactive",
    closed: "closed",
};

const getDefaultStepState = () => {
    let state = !hasShareParam() ? [
        stepStates.active,
        stepStates.inactive,
        stepStates.inactive,
        stepStates.inactive,
        stepStates.inactive,
    ] : [
        stepStates.filled,
        stepStates.filled,
        stepStates.filled,
        stepStates.filled,
        stepStates.filled,
    ];

    if (getCalculatorType() === CALCULATOR_TYPES.watWordenMijnMaandLasten) {
        state = state.filter((v, i) => i !== 2)
    }

    return state;
}

export const defaultStepsState = getDefaultStepState();

export const removeDotsComas = (calculator) => {
    const calculatorCopy = { ...calculator };

    for (let field in calculator) {
        if (
            typeof calculator[field] === "string" &&
            calculator[field].search(/,|\./gm) !== -1
        ) {
            calculatorCopy[field] = calculator[field].replace(/,|\./g, "");
        }
    }

    return calculatorCopy;
};

export const rewriteRadioOptionsClasses = (parent, classes) => {
    const el = document.getElementsByClassName(parent);

    if (typeof el[0] !== "undefined") {
        for (let i = 0; i < el[0].children.length; i++) {
            el[0].children[i].classList.add(`${parent}-${classes[i]}`);
        }
    }
};

export const rewriteSelectIds = (parent, prefix) => {
    setTimeout(function () {
        const el = document.getElementsByClassName(parent);
        if (typeof el[0] !== "undefined") {
            for (var i = 0; i < el[0].children.length; i++) {
                el[0].children[i].id = `${prefix}-${parseInt(
                    el[0].children[i].innerHTML
                )}`;
            }
        }
    });
};

export const numberToCurrency = (number, format = true) => {
    if (number && !format) {
        return `€ ${number}`;
    } else if(number && format) {
      const language = getLanguage();
      const locale = (language === 'nl') ? 'nl-NL' : 'en-US';
        var formatter = new Intl.NumberFormat(locale, {
            //style: 'currency',
            //currency: 'EUR',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        });
        return `€ ${formatter.format(number)}`;
    }
}

export const currencyToNumber = (value, mustBeNumber, log) => {
    if (typeof value === 'number') return value;
    if (value) {
      value = value.replaceAll("€", "");
      value = value.replaceAll(/[,.]/g,'');
      value = value.replaceAll(/\s/g, '');
    } else {
      value = null;
    }
    //value = (value) ? value.replaceAll("€ ", "") : null;
  if (log) {
    //console.log(value)
  }
    if (value) {
        value = parseFloat(value);
        if(Math.round(value) !== value) {
            value = value.toFixed(2);
        }

        return Math.round(value);
    }
    return (!mustBeNumber) ? value : 0;
};

export const remapObject = (object, mapping) => {
    const result = {};
    for (const prop in object) {
        for (const map in mapping) {
            if (map === prop) {
                result[mapping[map]] = object[prop];
            }
        }
    }
    return result;
};

export const monthDiff = (dateFrom, dateTo) => {
    return dateTo.getMonth() - dateFrom.getMonth() +
    (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
}

export const convertToDateObject = (dateString) => {
    const parts = dateString.split('-');
    return new Date(parts[0], parts[1] - 1, parts[2]);
}

export const getPercentage = (amount, percentage) => {
  //console.log(Math.round((amount / 100) * percentage))
  return Math.round((amount / 100) * percentage);
}

export const getLanguage = () => {
    return window.location.pathname.includes('/en/') ? 'en' : 'nl';
}

export const setBodyDataForPdf = (state) => {
    let bodyData = {
        yearlyIncome: state.ApplicantYearlyIncome ? state.ApplicantYearlyIncome : 0,
        yearlyIncomePartner: state.PartnerYearlyIncome ? state.PartnerYearlyIncome : 0,
        creditsAndLoans: state.HasLoans ? (+state.Loans +state.StudentDebtMonthlyPayment +state.Alimony +state.PrivateLeaseAmount) : 0,
        maximumMortgage: state.response.maxMortgageAmount ? state.response.maxMortgageAmount : 0,
        grossMonthlyCosts: state.response.grossMonthlyCost ? state.response.grossMonthlyCost : 0,
        netMonthlyCosts: state.response.netMonthlyCost ? state.response.netMonthlyCost : 0,
        applicableGrossMonthlyCosts: state.response.grossMonthlyCostHouse ? state.response.grossMonthlyCostHouse : 0,
        applicableNetMonthlyCosts: state.response.netMonthlyCostHouse ? state.response.netMonthlyCostHouse : 0,
        askingHousePrice: (state.Woning) ? state.Woning : 0,
        //buyerCosts: state.response.buyerCosts ? state.response.buyerCosts : 0,
        //houseTotalCosts: state.response.totalNeededToBuyHouse ? state.response.totalNeededToBuyHouse: 0,
        ownResources: state.OwnResources ? state.OwnResources : 0,
        homeEquity: state.HomeEquity ? state.HomeEquity : 0,
        extraInsert: state.response.extraMoneyNeeded ? state.response.extraMoneyNeeded : 0,
        mortgageType: state.MortgageType === "Annuïteitenhypotheek" ? "Annuïteiten" : "Lineair",
        interest: state.Interest ? state.Interest : 0,
        fixedInterestPeriod: state.RentevastePeriode ? state.RentevastePeriode : 1,
        riskClass: state.response.riskClass ? state.response.riskClass : 0,
        isNhg: state.response.isNhg,
        hasHouse: state.HasHouse === "true",
        mortgageHistory: null,
        calculatorType: getCalculatorType()

    };

    if (state.HasHouse === "true" && !state.WantsToSkipMortgageQuestions) {
        bodyData = {...bodyData, mortgageHistory: {
                houseSalePrice: state.HomeEquity,
                houseSaleCosts: state.HomeEquityCosts,
                houseMortgageValue: state.HomeMortgageAmount,
                housePartMortgageValue: (state.HomeMortgageOtherPartAmount) ? state.HomeMortgageOtherPartAmount : 0,
                houseMortgageDateStart: (state.HomeMortgageStart) ? `${state.HomeMortgageStart}T00:00:00.299Z`: null, // "2021-08-17T20:53:40.651Z",
                isHouseMortageDateStartedBefore2013: state.HomeMortgageStartBefore2013,
                isHouseMortageCompletelyAnnuityOrLinear: state.HomeMortgageIsBeingPaidOff
            }
        }
    }

    return bodyData;
}

/*
HomeMortgageAmount(pin):250000
HomeMortgageIsBeingPaidOff(pin):true
HomeMortgageStartNotKnown(pin):true
HomeMortgageStartBefore2013(pin):false
HomeMortgageOtherPartAmount(pin):null
 */

export const createPostObject = (data, type) => {

  data.StudentDebtMonthlyPayment = calculateStudentDebt(data.StudentDebtAmount, data.Interest);

  if (data.ApplicantAge > 67) {
        data.ApplicantAOW = data.ApplicantYearlyIncome;
    }

    if (data.PartnerAge > 67) {
        data.PartnerAOW = data.PartnerYearlyIncome;
    }
    let object = {
        mortgageType: (data.MortgageType === "Annuïteitenhypotheek" || data.MortgageType === "Annuiteitenhypotheek") ? 4 : 9,
        applicant: {
            age: (data.ApplicantAge === 0) ? 35 : data.ApplicantAge,
            yearlyIncome: data.ApplicantYearlyIncome || 0,
            statePensionIncome: data.ApplicantAOW,
            oldAgePensionIncome: data.ApplicantAnnualPensionIncome,
        },
        partner: {
            age: (data.PartnerAge === 0) ? 35 : data.PartnerAge,
            yearlyIncome: data.PartnerYearlyIncome || 0,
            statePensionIncome: data.PartnerAOW,
            oldAgePensionIncome: data.PartnerAnnualPensionIncome,
        },
        interestRate: data.Interest,
        fixedInterestPeriod: (data.RentevastePeriode > 1) ? data.RentevastePeriode : 1,
        loans: (data.Loans + data.StudentDebtMonthlyPayment + data.PrivateLeaseAmount),
        alimony: data.Alimony,

    };

    if (getCalculatorType() === CALCULATOR_TYPES.watWordenMijnMaandLasten) {
        const {stepState, stepNumber} = store.getState().calculator;
        if(stepState[1] === 'inactive' && stepNumber === 0) {
            object.applicant.yearlyIncome = 34000;
            object.applicant.age = 35;
        }
    }

    if (data.HasHouse === "true" && !data.WantsToSkipMortgageQuestions) {
      object = {
        ...object, ...{ mortgageHistory : {
            houseSalePrice: data.HomeEquity,
            houseSaleCosts: data.HomeEquityCosts,
            houseMortgageValue: data.HomeMortgageAmount,
            housePartMortgageValue: (data.HomeMortgageOtherPartAmount) ? data.HomeMortgageOtherPartAmount : 0,
            houseMortgageDateStart: (data.HomeMortgageStart) ? `${data.HomeMortgageStart}T20:55:57.299Z`: null, // "2021-08-17T20:53:40.651Z",
            isHouseMortageDateStartedBefore2013: data.HomeMortgageStartBefore2013,
            isHouseMortageCompletelyAnnuityOrLinear: data.HomeMortgageIsBeingPaidOff
          }
        }
      };

    }

    if (type === 'monthlycostsbymortgage') {

        object = {
            ...object, ...{
                mortageAmount: (data.maxMortgageAmount === 0) ? 1 : data.maxMortgageAmount
            }
        };

    }
    if (type === 'caniaffordthishouse') {
        object = {
            ...object, ...{
                isNewBuilding: parseInt(data.IsNieuwbouw) === 2,
                purchasePrice: parseInt(data.Woning),
                ownMoney: (data.OwnResources) ? parseInt(data.OwnResources) : 0,
                surplus: (data.HomeEquity)? parseInt(data.HomeEquity) : 0
            }
        };
    }

    if (typeof data.ApplicantAOW === 'undefined' || !data.ApplicantAOW) {
        delete object.applicant.statePensionIncome;
    }

    if (!data.ApplicantAnnualPensionIncome) {
        delete object.applicant.oldAgePensionIncome;
    }

    if (typeof data.PartnerAOW === 'undefined' || !data.PartnerAOW) {
        delete object.partner.statePensionIncome;
    }

    if (!data.PartnerAnnualPensionIncome) {
        delete object.partner.oldAgePensionIncome;
    }

    if (!data.HasPartner) {
        delete object.partner;
    }

    return object;
}

export function hasShareParam() {
    const params = parseSearchQuery(window.location.search);
    if (params && typeof params.share !== 'undefined') {
        return params.share;
    }
}

export function addOfficeIdParamToLink(link) {
  const params = parseSearchQuery(window.location.search);
  if (params && typeof params.officeid !== 'undefined') {
    return `${link}?officeid=${params.officeid}`;
  }
  return link;
}

export const getAdditionalEnergyLabelAmount = (energyLabel, isSustainabilityUplift) => {
  switch (energyLabel) {
    case "-":
      return isSustainabilityUplift ? 10000 : 0;
    case "G":
    case "F":
    case "E":
      return isSustainabilityUplift ? 20000 : 0;
    case "D":
    case "C":
      return isSustainabilityUplift ? 15000 : 5000;
    case "B":
    case "A":
      return isSustainabilityUplift ? 10000 : 10000;
    case "AP":
    case "APP":
      return isSustainabilityUplift ? 10000 : 20000;
    case "APPP":
      return isSustainabilityUplift ? 10000 : 30000;
    case "APPPP":
      return isSustainabilityUplift ? 0 : 40000;
    case "APPPPP":
      return isSustainabilityUplift ? 0 : 50000;
    default:
      return 0;
  }
}

// create a function to calculate the student debt
export const calculateStudentDebt = (studentDebtAmount, currentInterestRate) => {
  // Determine the multiplier based on the current mortgage interest rate
  let multiplier;
  if (currentInterestRate < 2.00) {
    multiplier = 1.05;
  } else if (currentInterestRate < 2.50) {
    multiplier = 1.10;
  } else if (currentInterestRate < 3.00) {
    multiplier = 1.15;
  } else if (currentInterestRate < 3.50) {
    multiplier = 1.20;
  } else if (currentInterestRate < 4.00) {
    multiplier = 1.20;
  } else if (currentInterestRate < 4.50) {
    multiplier = 1.25;
  } else if (currentInterestRate < 5.00) {
    multiplier = 1.3;
  } else if (currentInterestRate < 5.50) {
    multiplier = 1.3;
  } else if (currentInterestRate < 6.00) {
    multiplier = 1.35;
  } else {
    multiplier = 1.40;
  }

  // Apply the multiplier to the cost
  const costWithMultiplier = Math.round(studentDebtAmount * multiplier);
  //console.log('studentLoanAmount', costWithMultiplier);
  //console.log('currentInterestRate', currentInterestRate);
  //console.log('multiplier', multiplier);
  return costWithMultiplier;
};


export const checkMobileBrowser = (browserName) => {
  return (
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
  browserName
  ) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
  browserName.substr(0, 4)
  )
  );
};
